var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Error',{attrs:{"title":"ログインが成功しました","lead":"当サービスはPhorbsから開く必要があります","top-link":false},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v("\n    現在のタブを閉じて、Phorbsから操作を続けてください。\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }